import { Box, Button, Checkbox, Grid, IconButton, Radio, TextField, Tooltip, Typography } from "@mui/material"
import CustomAccordion from "../../../../../../../../components/accordion"
import { icons } from "../../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import React, { ChangeEvent, useCallback, useContext, useEffect, useMemo, useReducer } from "react"
import { useStyles } from "./styles"
import { Priority } from "../../../../../../../../utils/enums/priority"
import CrudModal from "../../../../../../../../components/modal/crudModal"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { useInput } from "./hooks/useInputs"
import { useCreatEdit } from "./hooks/useForm"
import { generalDisabled } from "../../../../../../../../utils/validate/validate"
import { ServiceContext } from "../../../../context"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { NoResponse } from "../../../../../../../../components/errors/noResponse"
import { ACTIONS } from "../../enums/actions"
import { reducer, initialState, normalizeString } from "./utils/body"
import { Subcategories, User, Priority as Priorities, SubcategoriesAndParent } from "../../../../../../../../service/catalog/response"
import { Item } from "../../../../../../../../utils/types/generals"
import { useParams } from "react-router-dom"


const Category = React.memo(({
    title, 
    childs, 
    id, 
    parentId, 
    user, 
    requestText,
    priority, 
    handleOpenModal, 
    handleOpenModalDelete,
    addToParent,
    deleteToParent,
    check,
    providers
}:{
    title:string, 
    childs?:Subcategories[], 
    id:number, 
    parentId?:number, 
    user?:User, 
    priority?:Priorities, 
    requestText?: boolean,
    handleOpenModal?: (id?: number, name?: string, priority?: Priorities, user?:User, requestText?: boolean) => void, 
    handleOpenModalDelete?: (id: number) => void,
    addToParent?: (id: number) => void,
    deleteToParent?: (id: number) => void,
    check?: boolean,
    providers?: Item[]
}) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { id: idCatalog } = useParams()
    const {data,onChange,handledata} = useCreatEdit()
    /* const [items, setItems] = useState< Item[] >() */
    const { input } = useInput({priority:data.priority?.value, items: providers})
    const hihgPriority: boolean = priority?.id == Priority.HIGH || priority?.id == Priority.URGENT
    const { addService, addNewsService, removeService, removeNewsService, editService, editOldService, editSubService, newSubcategories, newsCategories, subcategoriesToDelete, categoriesToDelete} = useContext(ServiceContext);
    const disableCategoryForm = useMemo(() => generalDisabled(input, data), [data, input])

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
      dispatch({type:ACTIONS.CHECKED_BY_PARENT,payload:{check:check}})
    }, [check])


    

    useEffect(()=>{
      dispatch({ type: ACTIONS.INITIALIZE_ARRAYS, payload: providers ?? [] })
    },[providers])

    const handleOpenModalSubService = useCallback((id?:number,name?:string,priority?:Priorities,user?:User, requestText?: boolean) => {
           
      if(id){
          const defaultPriority: Priorities = {id: Priority.HIGH ,name:''}
          dispatch({ type: ACTIONS.SET_EDIT_ID, payload: id });
          dispatch({ type: ACTIONS.SET_PRIORITY, payload: priority ?? defaultPriority });
          handledata({
            nameSubCategory:name,
            priority: {
                label:priority?.name,
                value:priority?.id
            }, 
            provider: user ? {label:user?.fullName,value:user?.id} : null ,
            textField: requestText
          })
        }
        dispatch({
            type: ACTIONS.OPEN_MODAL,
            payload: {
              title: id
                ? t("catalog.messages.editSubCategory")
                : t("catalog.messages.addSubCategory"),
              cancel: () => {
                dispatch({ type: ACTIONS.CLOSE_MODAL });
                handledata();
                dispatch({ type: ACTIONS.RESET_EDIT_ID });
                dispatch({ type: ACTIONS.SET_PRIORITY, payload: {id: 0, name: ''} })
              },
            },
          });
      }, []);

    const handleConfirm = () => {
        if (state.editId !== 0) {
          editService(
            state.editId,
            String(data.nameSubCategory),
            {id:Number(data.priority?.value),  name:String(data.priority?.label)},
            (data.priority?.value == Priority.HIGH || data.priority?.value == Priority.URGENT) && data.provider?.value
             ? {id:data.provider?.value ?? 0, fullName:String(data.provider?.label)}
             : undefined,
             data.textField
            )
          editOldService(
            state.editId,
            String(data.nameSubCategory),
            {id:Number(data.priority?.value),  name:String(data.priority?.label)},
            (data.priority?.value == Priority.HIGH || data.priority?.value == Priority.URGENT) && data.provider?.value
             ? {id:data.provider?.value ?? 0, fullName:String(data.provider?.label)}
             : undefined,
            id,
            data.textField
          )
        }else{
          const newService: SubcategoriesAndParent = {
            parentId: id,
            id: Math.floor(Math.random() * 10000) + 1,
            name:String(data.nameSubCategory),
            priority:{
              id: Number(data.priority?.value),
              name:String(data.priority?.label)
            },
            user: data.provider?.value ? {
                id:data.provider?.value,
                fullName:String(data.provider?.label),
            } : null,
            requestText: !!data.textField,
          }
          addService(newService,id)
          if(idCatalog){
            addNewsService(newService,id)
          }
        }
        dispatch({ type: ACTIONS.CLOSE_MODAL });
        handledata();
        dispatch({ type: ACTIONS.RESET_EDIT_ID });
        dispatch({ type: ACTIONS.SET_PRIORITY, payload: {id: 0, name: ''} })
    }

    const handleOpenModalDeleteSubService = useCallback((idNew:number) => {
        dispatch({
          type: ACTIONS.OPEN_MODAL_DELETE,
          payload: {
            title: t("catalog.form.deleteTitleSubService"),
            description: t("catalog.form.deleteSubServiceDescription"),
            confirm: () => {
              removeService(idNew);
              if(idCatalog){
                removeNewsService(idNew,id);
              }
              dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
            },
            cancel: () => {
              dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
            },
          },
        });
      }, [newSubcategories, newsCategories, subcategoriesToDelete, categoriesToDelete]);
    
    const closeModalDelete = () => {
        dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
    };

    const handleOpenModalChangePriority = () => {
      dispatch({
        type: ACTIONS.OPEN_MODAL_DELETE,
        payload: {
          title: t("catalog.form.changePriority"),
          description: t("catalog.form.changePriorityDescription"),
          confirm: () => {
            dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
            dispatch({ type: ACTIONS.SET_PRIORITY, payload: {id: Number(data.priority?.value), name: String(data.priority?.label)} });
          },
          cancel: () => {
            handledata({
              priority: {
                label: state.priority?.name,
                value: state.priority?.id 
              }
            })
            dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
          },
        },
      });
    }

    useEffect(()=>{

      if( (state.priority?.id === Priority.HIGH || state.priority?.id === Priority.URGENT) && ( data.priority?.value === Priority.MEDIUM || data.priority?.value === Priority.LOW )){
        handleOpenModalChangePriority()
      }

    },[data.priority])

    const handleOpenModalProvider = (id?:number) => {
      dispatch({
        type: ACTIONS.OPEN_MODAL_PROVIDER,
        payload: {
          title: t("catalog.messages.selectProvider"),
          description: parentId
            ? t("catalog.messages.assignProviderSubCategory")
            : t("catalog.messages.assignProviders"),
          cancel: () => {
            dispatch({ type: ACTIONS.CLOSE_MODAL_PROVIDER });
            dispatch({ type: ACTIONS.HANDLE_PROVIDERS_NOT_CHECK });
          },
        },
      });
      if(id){
        dispatch({ type: ACTIONS.HANDLE_PROVIDERS_CHECK, payload: { id:user?.id, name:user?.fullName } })
      }
    }

    const toggleExpand = () => {
        dispatch({ type: ACTIONS.TOGGLE_EXPAND });
    }

    const handleEdit = () =>{
        if(handleOpenModal){
            handleOpenModal(id,title,priority,user,requestText)
        }
    }

    const handleDelete = () => {
        if(handleOpenModalDelete){
            handleOpenModalDelete(id)
        }
    }

    const addChildren = useCallback((id: number) => {
      dispatch({
        type: ACTIONS.ADD_CHILDREN,
        payload: {id:id},
      });
    }, []);

    const deleteChildren = useCallback((id: number) => {
      dispatch({
        type: ACTIONS.DELETE_CHILDREN,
        payload: {id:id},
      });
    }, []);

    const handleChecked = () => {
      if(state.checked){
        if(deleteToParent){
          deleteToParent(id)
        }
      }else{
        if(addToParent){
          addToParent(id)
        }
      }
      dispatch({ type: ACTIONS.CHECKED });
    }

    const handleAddAllChildren = () => {
      dispatch({ type: ACTIONS.ADD_ALL_CHILDREN, payload:{childs:childs ?? []} })
    }

    const handleDeleteAllChildren = () => {
      dispatch({ type: ACTIONS.DELETE_ALL_CHILDREN })
    }

    const handleAssingProvider = () => {

      const provider: User | undefined = state.providerValue ? {
        id:state.providerValue?.id ?? 0,
        fullName:state.providerValue?.name ?? ""
      } : undefined

      if(parentId){
        editService(id,title,priority,provider,requestText)
        editOldService( id, title, priority, provider, parentId, requestText )
      }else{
        editSubService(id,(state.idChildren || []),provider)
        if(childs){
          childs.forEach(child => {
            if( child.priority.id == Priority.HIGH || child.priority.id == Priority.URGENT){
              editOldService( child.id, child.name, child.priority, provider, id, child.requestText )
            }
          })
          
        }
        dispatch({ type: ACTIONS.DELETE_ALL_CHILDREN })
      }   
      dispatch({ type: ACTIONS.CLOSE_MODAL_PROVIDER });
      dispatch({ type: ACTIONS.HANDLE_PROVIDERS_NOT_CHECK });
  }

  const handleChangeSearchValue = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: ACTIONS.SEARCH_VALUE,payload:event.target.value})
    dispatch({ type: ACTIONS.FILTER_PROVIDERS_BY_VALUE})
  };

  const handleChangeSearchSubServiceValue = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: ACTIONS.SEARCH_SUBSERVICE_VALUE,payload:event.target.value})
  };


  return (<>
    <CustomAccordion
        accordionProps={{ sx: styles.accordion }}
        title={(
        <Box sx={styles.containerHeader(!!parentId)}>

            {!parentId && (
                <Typography sx={styles.headerTitle}>{title}</Typography>
            )}

            {!!parentId && (
                <Box sx={styles.titleChild}>
                    { hihgPriority && (
                        <Checkbox
                            className='remove-m'
                            name="delete"
                            checked={state.checked}
                            onChange={() => {
                              handleChecked()
                            }}
                        />
                    )}
                    
                    <Box sx={styles.box}>
                        <Typography sx={styles.headerSecondTitle}>{title}</Typography>
                        <Typography sx={styles.headerSubTitle}>{t('catalog.subcategory')}</Typography>
                    </Box>
                    <Box sx={styles.box}>
                        <Typography sx={styles.headerSecondTitle}>{user ? user.fullName : '-'}</Typography>
                        <Typography sx={styles.headerSubTitle}>{t('catalog.provider')}</Typography>
                    </Box>
                </Box>
            )}

            <Box sx={styles.headerAction(!!parentId)}>

                {!!priority && (
                    <Typography sx={styles.status(hihgPriority)}>{t(`catalog.priority.${priority.id}`)}</Typography>
                )}

                {!parentId && (
                    <Tooltip title={t('ToolTips.supervisor')}>
                      <span>
                        <IconButton disabled={!state.idChildren?.length} onClick={()=>handleOpenModalProvider()}>{icons('user')} </IconButton>
                      </span>
                    </Tooltip>
                )}

                { hihgPriority && (
                    <Tooltip title={t('ToolTips.supervisor')}>
                        <IconButton onClick={()=>handleOpenModalProvider(id)}>{icons('user')} </IconButton>
                    </Tooltip>
                )}

                <Tooltip title={t('ToolTips.edit')}>
                    <IconButton onClick={handleEdit}>{icons('edit')} </IconButton>
                </Tooltip>

                <Tooltip title={t('ToolTips.delete')}>
                    <IconButton onClick={handleDelete}>{icons('delete')} </IconButton>
                </Tooltip>

                {!parentId && (
                    <Tooltip title={t(`ToolTips.${state.expand ? 'collapse':'expand'}`)}>
                        <IconButton 
                            onClick={(e) => {
                                e.stopPropagation(); 
                                toggleExpand(); 
                            }} 
                            sx={[styles.arrow, styles.rotate(state.expand)]}
                        >{icons('arrow-down')} </IconButton>
                    </Tooltip>
                )}

            </Box>

        </Box>
        )}
        description={(
            <Box sx={styles.description}> 
                { childs && (
                  <Box sx={styles.containerSelectButons}>
                    <Box>
                      <Button
                        sx={styles.addService}
                        onClick={handleAddAllChildren}
                        disabled = {!childs.length}
                      >
                        {t('catalog.button.selectAll')}
                      </Button>
                      <Button
                        sx={styles.addService}
                        onClick={handleDeleteAllChildren}
                        disabled = {state.idChildren && state.idChildren?.length<1}
                      >
                        {t('catalog.button.deselectAll')}
                      </Button>
                    </Box>
                    <TextField
                      label={t('catalog.inputs.searchProviderOrCatalog')}
                      variant="outlined"
                      value={state.searchSubServiceValue}
                      onChange={handleChangeSearchSubServiceValue}
                      sx={styles.wdth}
                    />
                  </Box>
                )}
                <Box sx={styles.containerChildren}>
                  {childs && childs.filter((child) => normalizeString(child.name || "").includes(normalizeString(state.searchSubServiceValue || "")) || normalizeString(child.user?.fullName || "").includes(normalizeString(state.searchSubServiceValue || "")) ).map((child) =>(
                      <Category key={child.id} requestText={child.requestText} providers={providers} title={child.name} id={child.id} parentId={id}  user={child.user ?? undefined} priority={child.priority} handleOpenModal={handleOpenModalSubService} handleOpenModalDelete={handleOpenModalDeleteSubService} addToParent={addChildren} deleteToParent={deleteChildren} check={state.idChildren?.includes(child.id)}/>
                  ))}
                  {childs && childs.filter((child) => normalizeString(child.name || "").includes(normalizeString(state.searchSubServiceValue || "")) || normalizeString(child.user?.fullName || "").includes(normalizeString(state.searchSubServiceValue || "")) ).length == 0 && (
                    <NoResponse label={t('catalog.noCatalog')} />
                  )}
                </Box>
                <Box>
                  <IconButton
                      sx={styles.addService}
                      className="mt"
                      onClick={() => {
                          handleOpenModalSubService()
                      }}
                  >
                      {icons('add-outlined')} <Typography>{t('catalog.button.addSubService')}</Typography>
                  </IconButton>
                </Box>
            </Box>
        )}
        
        expandIcon={null}
        expanded={parentId ? !state.expand:state.expand}
    />

    <CrudModal
        disable={disableCategoryForm}
        sx={styles.crudModalCreate}
        open={state.openModal?.open ?? false}
        close={() => { if (state.openModal?.cancel) { state.openModal?.cancel() } }}
        title={state.openModal?.title ?? ""}
        buttonText={t('general.save')}
        children={
            <DinamicForm input={Object.values(input)} onChange={onChange} values={data} justifyContentLeft />
        }
        next={handleConfirm}
    />
    <CrudModal
        disable={false/* state.providerValue?.id==0 */} 
        sx={styles.crudModal}
        description={state.openModalProvider?.description ?? ""}
        open={state.openModalProvider?.open ?? false}
        close={() => { if (state.openModalProvider?.cancel) { state.openModalProvider?.cancel() } }}
        title={state.openModalProvider?.title ?? ""}
        buttonText={t('catalog.button.assign')}
        children={
          <Box>
            <Box sx={styles.containerSearchInput}>
              <TextField
                label={t('catalog.inputs.searchProvider')}
                variant="outlined"
                value={state.searchValue}
                onChange={handleChangeSearchValue}
                sx={styles.wdth}
              />
            </Box>
            <Grid container spacing={2} sx={styles.grid} >
              {!!state.provider && state.provider.map(provider =>(
                <Grid key={provider.value} item xs={4} >
                  <Box sx={styles.containerRadio}>
                    <Radio
                      name="delete"
                      checked={state.providerValue?.id==provider.value}
                      onClick={() => {  //onChange
                        dispatch({ type: ACTIONS.HANDLE_PROVIDERS_CHECK,payload: !state.providerValue ? {id:provider.value,name:provider.label} : (state.providerValue?.id!==provider.value) ? {id:provider.value,name:provider.label} : {id:undefined,name:undefined} })
                      }}
                    />
                    <Typography>{t('catalog.provider')} <span>{provider.label}</span></Typography>
                  </Box>
                </Grid>
              ))}
              {!state.provider?.length && (
                <NoResponse label={t('catalog.noProvider')} />
              )}
            </Grid>
          </Box>
        }
        next={handleAssingProvider}
    />
    <SimpleModal
        open={state.openModalDelete?.open ?? false}
        close={() => {
            closeModalDelete()
        }}
        title={state.openModalDelete?.title}
        description={state.openModalDelete?.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        back={() => {
          if (state.openModalDelete?.cancel) {
            state.openModalDelete.cancel()
          }
        }}
        next={() => {
            if (state.openModalDelete?.confirm) {
                state.openModalDelete.confirm()
            }
        }}
    />
  </> 
  )
});

export { Category }